'use strict';

import React from 'react';

import Store from '../../stores/PensionTypeStore.js';
import InvestmentAllocationStore from '../../stores/InvestmentAllocationStore.js';
import Action from '../../actions/PensionTypeActions.js';
import InvestmentAllocationActions from '../../actions/InvestmentAllocationActions';
import ApplicationActions from '../../actions/ApplicationActions.js';

import Header from '../Common/SectionHeader.jsx';
import PensionTypeBenefit from './PensionTypeBenefits.jsx';
import autoBind from 'react-autobind';
import RadioInput from '../Common/RadioInput.jsx';
import UserNotification from '../Common/UserNotification.jsx';
import Formatter from '../../utils/Formatter.js';
import _ from 'lodash';

import Constants from '../../constants/PensionTypeConstants.js';
const BenefitSelection = Constants.BenefitSelection;
const DisclaimerText = Constants.DisclaimerText;

function getSectionState() {
    return {
        model: Store.getPensionTypeModel(),
        formError: Store.getFormError(),
        pensionTypeSelection: Store.getSelection(),
        crossSectionDependencyMsg: Store.getCrossSectionDependencyMsg(),
        isUserNotificationClosed: false
    }
}

export default class PensionTypeSection extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = getSectionState();
    }

    _onChange() {
        this.setState(getSectionState());
    }

    selectHandler(e) {
        var investmentListAvailable = InvestmentAllocationStore.investmentListAvailable();
        Action.selectPensionType(e.target.model, e.target.value, e.target.id, investmentListAvailable);
        if (this.state.formError.length === 0) {
            ApplicationActions.setPensionTypeSelected(e.target.value);
            InvestmentAllocationActions.clearInvestmentOptions();
        }
    }

    benefitsHandler(e) {
        Action.selectBenefit(e.target.model, e.target.value, e.target.id);
    }

    componentDidMount() {
        Store.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        Store.removeChangeListener(this._onChange);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.model.selectedPensionType !== this.state.model.selectedPensionType) {
            ApplicationActions.isPreRetirement(this.state.model.selectedPensionType);
        }
        if (!_.isEqual(prevState.pensionTypeSelection, this.state.pensionTypeSelection)) {
            ApplicationActions.sendPensionTypeOptions(this.state.pensionTypeSelection);
        }
    }

    getCrossSectionMsg () {
        var crossSectionMsg = Formatter.formatString(this.props.content.crossSectionParentText, { parentSection: this.props.content.pensionType.sectionHeader, sections: _.pluck(this.state.crossSectionDependencyMsg, 'content').join(', ') });

        return crossSectionMsg;
    }

    toggleUserNotificationClose () {
        this.setState({ isUserNotificationClosed: true, crossSectionDependencyMsg: this.state.crossSectionDependencyMsg.splice(0, this.state.crossSectionDependencyMsg.length) });
    }

    render() {
        let age = this.state.model.currentAge;
        let benefitItem = this.state.model.selectedBenefitItem;
        let pensionType = this.state.model.selectedPensionType;

        let benefitEntries = ((BenefitSelection[pensionType] === undefined)
            ? []
            : BenefitSelection[pensionType])
                .filter(function (element) {
                    return element.minAgeLimit <= age && age <= element.maxAgeLimit;
                });
        benefitEntries = (benefitEntries && benefitEntries.length === 0) ? null : benefitEntries; // prevents spinner from appearing

        let disclaimerText = DisclaimerText[benefitItem];
        if (pensionType && pensionType === Constants.PensionTypeSelectionNames.RETIREMENT) {
            disclaimerText = DisclaimerText[Constants.PensionTypeSelectionNames.RETIREMENT.toUpperCase()];
        }
        if (disclaimerText === Constants.DisclaimerConstants.COMMON_DISCLAIMER) {
            disclaimerText = this.props.content.pensionType.commonDisclaimer;
        }
        else if (disclaimerText === Constants.DisclaimerConstants.OTHER_COMMON_DISCLAIMER) {
            disclaimerText = this.props.content.pensionType.otherCommonDisclaimer;
        }
        else if (disclaimerText === Constants.DisclaimerConstants.DEATH_BENEFIT_DISCLAIMER) {
            disclaimerText = this.props.content.pensionType.deathBenefitDisclaimer;
        }

        if (this.state.formError.length) {
            disclaimerText = ''
        }

        let helpText = this.props.content.pensionType.pensionTypeHelpText;
        let generalDisclaimerText = this.props.content.pensionType.pensionTypeGeneralDisclaimerText;

        return (
            <div className="form-step">
                <Header focus={this.props.focus} sectionName="Pension type" sectionHelpText="Need help?" NeedHelpInfo={helpText}  />
                <UserNotification id="yourDetailsPensionUserNotification"
                    message={this.getCrossSectionMsg()}
                    onClick={this.toggleUserNotificationClose}
                    isHidden={!this.state.crossSectionDependencyMsg.length || this.state.isUserNotificationClosed} />
                <div className="container">
                    <RadioInput id="ptPensionTypeSelection"
                        model="selectedPensionType"
                        data={this.state.pensionTypeSelection}
                        value={pensionType}
                        label="Select pension or benefit type"
                        onChange={this.selectHandler}
                    />

                    <PensionTypeBenefit
                        value={this.state.model.selectedBenefitItem}
                        entries={benefitEntries}
                        disclaimerText={disclaimerText}
                        generalDisclaimerText={this.state.model.showGeneralDisclaimer ? generalDisclaimerText : null }
                        changeHandler={this.benefitsHandler}
                        errorList={this.state.formError}
                    />
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/PensionType/PensionTypeSection.jsx